import React, { useRef, useState, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Spinner } from '@shopify/polaris'

import DefaultPinData from '../../libs/default-pin'

import PinComponent from '../pin/pin'
import FileInputComponent from '../file-input'

import {actionAddNewPin, actionSetActivePin, actionUpdateItemField} from '../../store/actions'

import './preview-image-input.css'

const PreviewImageComponent = (props) => {
  const dispatch = useDispatch()
  const previewImageRef = useRef()
  const [isLoading, setIsLoading] = useState(false)
  const [wrapperDimension, setWrapperDimension] = useState({
    width: 0,
    height: 0
  })
  const pins = useSelector(state => state.activeItem.pins) || []
  const activeItem = useSelector(state => state.activeItem)

  /**
   * Get image dimention on image loaded event
   * @type {(...args: any[]) => any}
   */
  const onLoadImage = useCallback(() => {
    const rect = previewImageRef.current.getBoundingClientRect()

    const dimension = {
      top: rect.top + window.pageYOffset,
      left: rect.left + window.pageXOffset,
      width: previewImageRef.current.clientWidth,
      height: previewImageRef.current.clientHeight
    }
    setWrapperDimension(dimension)
    if (props.onImageLoaded) {
      props.onImageLoaded(dimension)
    }
  }, [])

  /**
   * Add new pin to pins array from redux state
   * @param e
   */
  const addNewPin = (e) => {
    const pinWidth = 30
    const left = (e.pageX - wrapperDimension.left - (pinWidth / 2) + 15) / wrapperDimension.width * 100
    const top = (e.pageY - wrapperDimension.top - (pinWidth / 2) + 15) / wrapperDimension.height * 100
    const data = {
      ...DefaultPinData,
      top: `${top}%`,
      left: `${left}%`
    }
    dispatch(actionAddNewPin(data))
    dispatch(actionSetActivePin(pins.length))
  }

  return (
    <div>
      <FileInputComponent
        loading={isLoading}
        name='image_url'
        label='Paste your image url or click "Upload an image" button to upload one'
        helpText='A Good photo should consists of multiple products. This photo can be inserted anywhere in your website.'
        value={activeItem.image_url}
        onChange={(key, value) => {
          dispatch(actionUpdateItemField(key, value))
          if (props.onChange) props.onChange(key, value)
        }}
        onFileStartUploading={() => setIsLoading(true)}
        onFileUploaded={() => setIsLoading(false)}
        error={props.error ? "Image is required" : false}
      />
      <div className={`preview-image${isLoading ? ' preview-image--loading' : ''}`}>
        {isLoading ? (
          <Spinner
            accessibilityLabel="Loading preview"
            hasFocusableParent={false}
          />
        ) : (
          activeItem.image_url && activeItem.image_url.length > 0 && <div>
            <span className='preview-image__label'>Preview</span>
            <div
              className='Polaris-MediaCard__MediaContainer preview-image__img js-preview-mapper'
              ref={previewImageRef}
            >
              {(pins.length > 0) && (
                <div className='preview-image__pins'>
                  {pins.map((pin, index) => <PinComponent pin={pin} index={index} key={index} wrapperDimension={wrapperDimension} />)}
                </div>)}
              <img
                onLoad={onLoadImage}
                src={activeItem.image_url}
                alt='Preview image'
                onClick={(e) => addNewPin(e)}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default PreviewImageComponent
